import { helpers } from '@vuelidate/validators';

const v6seg = '[a-fA-F\\d]{1,4}';
const v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
const v6 = `(
(?:${v6seg}:){7}(?:${v6seg}|:)|
(?:${v6seg}:){6}(?:${v4}|:${v6seg}|:)|
(?:${v6seg}:){5}(?::${v4}|(:${v6seg}){1,2}|:)|
(?:${v6seg}:){4}(?:(:${v6seg}){0,1}:${v4}|(:${v6seg}){1,3}|:)|
(?:${v6seg}:){3}(?:(:${v6seg}){0,2}:${v4}|(:${v6seg}){1,4}|:)|
(?:${v6seg}:){2}(?:(:${v6seg}){0,3}:${v4}|(:${v6seg}){1,5}|:)|
(?:${v6seg}:){1}(?:(:${v6seg}){0,4}:${v4}|(:${v6seg}){1,6}|:)|
(?::((?::${v6seg}){0,5}:${v4}|(?::${v6seg}){1,7}|:))
)(%[0-9a-zA-Z]{1,})?`
  .replace(/\s*\/\/.*$/gm, '')
  .replace(/\n/g, '')
  .trim();

export function useRulesValidator() {
  const isDomain = (value: string) => /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9а-яА-я][a-zA-Z0-9а-яА-я-_]+\.[a-zA-Zа-яА-я]{2,11}?$/.test(value);

  const nsServers = (valuesString: string)  => {
    let passed = true;
    const values = valuesString.trim() ? valuesString.trim().split('\n') : [];

    values.forEach((value) => {
      if (!new RegExp(`^${v4}$`).test(value.trim()) && !new RegExp(`^${v6}$`).test(value.trim()) && !isDomain(value.trim())) {
        passed = false;
      }
    });

    return !helpers.req(valuesString) || passed;
  }

  const ipv6Address = (value: string)=> !helpers.req(value) || new RegExp(`^${v6}$`).test(value);

  const ipv6Addresses = (valuesString: string = '')=> {
    let passed = true;
    const values = valuesString.trim() ? valuesString.trim().split('\n') : [];

    values.forEach((value) => {
      if (!new RegExp(`^${v6}$`).test(value.trim())) {
        passed = false;
      }
    });

    return !helpers.req(valuesString) || passed;
  };

  const ipv4Addresses = (valuesString: string = '')=> {
    let passed = true;
    const values = valuesString.trim() ? valuesString.trim().split('\n') : [];

    values.forEach((value) => {
      if (!new RegExp(`^${v4}$`).test(value.trim())) {
        passed = false;
      }
    });

    return !helpers.req(valuesString) || passed;
  };

  const isLandingPath = (landingPath: string = '')=> {
    if (!helpers.req(landingPath)) {
      return true;
    }

    const regEx = /([a-z-0-9]+)/;
    if (landingPath.length === 0 || !regEx.test(landingPath)) {
      return false;
    }

    const matches = landingPath.match(regEx);
    if (!matches || !matches[1]) {
      return false;
    }

    return matches[1] === landingPath;
  };

  return { isDomain, nsServers, ipv6Address, ipv6Addresses, ipv4Addresses, isLandingPath };
}
